import { Oil } from "./Oil";
import { OilPriceTab } from "./OilPriceTab";
import { RefuelOilTab } from "./RefuelOilTab";
import OilList from "./OilList/OilList";
import { GasStation } from "../../Modules/GasStation/GasStation";

export { Oil, OilPriceTab, RefuelOilTab, GasStation };

export default { Oil, OilPriceTab, RefuelOilTab, GasStation, OilList };
